// Maps the per-browser `ff_recordingAutoRecover` localStorage value to whether the
// NEW finalless/cross-device recovery branch runs.
//
// DEFAULT-ON, GLOBAL (Joshua's call 2026-06-30): an unset key runs the feature for
// everyone. "0" is a hard per-browser kill-switch (instant off, no redeploy); any
// other value (incl. "1") is on. The org-level feature flag is intentionally NOT
// consulted — this is a global rollout, not opt-in. A second `orgFlag` arg may
// still be passed by callers; it is ignored. Gates ONLY the new branch — never
// checkRecordings or the existing cross-device "open that device" nudge bar (those
// stay flag-INDEPENDENT, §14B).
export function isRecordingAutoRecoverEnabled(rawValue) {
  return rawValue !== "0";
}

// The guarded localStorage read every caller needs — done ONCE here so the three
// call sites (the recovery bar, the cross-device hook, the own-device drain) don't
// each re-implement the read with divergent catch behavior. Fails CLOSED on a
// storage exception (locked-down/privacy browsers): if we can't read the "0"
// kill-switch, don't run — and in that environment IndexedDB is unavailable too, so
// there's nothing to recover anyway.
export function isRecordingAutoRecoverEnabledFromStorage() {
  try {
    return isRecordingAutoRecoverEnabled(localStorage.getItem("ff_recordingAutoRecover"));
  } catch {
    return false;
  }
}
